import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  standalone: false,
})
export class FooterComponent implements OnInit {
  currentYear = new Date().getFullYear();
  version: string = "";

  constructor() {}

  ngOnInit() {
    this.fetchVersion();
  }

  fetchVersion() {
    fetch(`${environment.appURL}/assets/version.json`)
      .then((response) => response.json())
      .then((data) => {
        this.version = data.displayVersion; // Adjust this if your JSON structure is different
      })
      .catch((err) => {
        // console.error("Error fetching version:", err)
      });
  }
}
